// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"8ce4e2a9","103":"8ce4e2a9"}[chunkId] + ".chunk.css";
};